import styled from "styled-components";

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  gap: 20px;
  margin-top: 8px;

  button {
    height: 40px;
    width: 100px;
  }
`